export const OPEN_SW = 'OPEN_SW';
export const FOCUS_SW = 'FOCUS_SW';
export const CHANGE_SWINDEX = 'CHANGE_SWINDEX';
export const OPEN_TOPBTNSW = 'OPEN_TOPBTNSW';
export const CHANGE_BMAP = 'CHANGE_BMAP';
export const OPEN_PROB = 'OPEN_PROB';
export const OPEN_EDITER = 'OPEN_EDITER';
export const OPEN_HYPERPARAM = 'OPEN_HYPERPARAM';
export const OPEN_DBEDITOR = 'OPEN_DBEDITOR';
export const CHANGE_SHOWCHK = 'CHANGE_SHOWCHK';
export const SHOW_REGION_MODEL_WINDOW = 'SHOW_REGION_MODEL_WINDOW';
export const OPEN_EST_BORING = 'OPEN_EST_BORING';
export const SELECT_WATER_SHED = 'SELECT_WATER_SHED';
export const CHANGE_SW_POSITION = 'CHANGE_SW_POSITION';
export const CHANGE_WDATA_CAT = 'CHANGE_WDATA_CAT';
export const SHOW_TESTDATA_WINDOW = 'SHOW_TESTDATA_WINDOW';
export const SHOW_MEATIME_WINDOW = 'SHOW_MEATIME_WINDOW';
export const SHOW_MEATIME_EDITERWINDOW = 'SHOW_MEATIME_EDITERWINDOW';
export const SHOW_OUTTIME_WINDOW = 'SHOW_OUTTIME_WINDOW';
export const SHOW_INPUTTEMP_WINDOW = 'SHOW_INPUTTEMP_WINDOW';
export const SHOW_DETAIL_EDITERWINDOW = 'SHOW_DETAIL_EDITERWINDOW';

export function openSwAction(value) {
    return {
        type: OPEN_SW,
        value: value
    };
}

export function focusSwAction(focusSw) {
    return {
        type: FOCUS_SW,
        focusSw: focusSw
    };
}

export function changeSwIndexAction(arr) {
    return {
        type: CHANGE_SWINDEX,
        arr: arr
    };
}

export function openTopBtnSwAction(value) {
    return {
        type: OPEN_TOPBTNSW,
        value: value
    };
}

export function changeBmapAction(bmap) {
    return {
        type: CHANGE_BMAP,
        bmap: bmap
    };
}

export function openProbAction(isOpen) {
    return {
        type: OPEN_PROB,
        isOpen: isOpen
    };
}

export function openEditerAction(id) {
    return {
        type: OPEN_EDITER,
        id: id
    };
}

export function openHyperParamAction(mode) {
    return {
        type: OPEN_HYPERPARAM,
        mode: mode
    };
}

export function openDBEditorAction(isOpen) {
    return {
        type: OPEN_DBEDITOR,
        isOpen: isOpen
    };
}
export function changeShowChkAction(value, data) {
    return {
        type: CHANGE_SHOWCHK,
        value: value,
        data: data
    };
}
export function showRegionModelWindowAction(isVisible) {
    return {
        type: SHOW_REGION_MODEL_WINDOW,
        isVisible: isVisible
    };
}
export function openEstBoringAction(id) {
    return {
        type: OPEN_EST_BORING,
        id: id
    };
}
export function selectWaterShedAction(isSelectable) {
    return {
        type: SELECT_WATER_SHED,
        isSelectable: isSelectable
    };
}
export function changeSwPosiAction(value) {
    return {
        type: CHANGE_SW_POSITION,
        value: value
    };
}

export function changewDataCatAction(value) {
    return {
        type: CHANGE_WDATA_CAT,
        value: value
    };
}

export function showTestDataWindowAction(isVisible) {
    return {
        type: SHOW_TESTDATA_WINDOW,
        isVisible: isVisible
    };
}

export function showMeaTimeWindowAction(isVisible) {
    return {
        type: SHOW_MEATIME_WINDOW,
        isVisible: isVisible
    };
}

export function showMeaTimeEditerWindowAction(isVisible) {
    return {
        type: SHOW_MEATIME_EDITERWINDOW,
        isVisible: isVisible
    };
}

export function showOutTimeWindowAction(isVisible) {
    return {
        type: SHOW_OUTTIME_WINDOW,
        isVisible: isVisible
    };
}

export function showInputTempWindowAction(isVisible) {
    return {
        type: SHOW_INPUTTEMP_WINDOW,
        isVisible: isVisible
    };
}

export function showDetailEditerWindowAction(isVisible) {
    return {
        type: SHOW_DETAIL_EDITERWINDOW,
        isVisible: isVisible
    };
}

